module.exports = __webpack_public_path__ + "static/media/ic_bank_partial_added.6910ca60.svg";